import {HighlightRow} from "../10. Battle/types";

export const MAIN_SERVER_URL = `https://${window.location.host}`

export interface VideoInfo {
	kbs: number
	fps: number
	tbr: number
	audioHz: number
}

export interface HLBattle {
	Id: number
	Name: string
	BattleId: number
	MMAEventList: number[]
	FunnyEventList: number[]
}


export interface HLEvent {
	Id: number
	Name: string
	EventId: number
	HLBattles: number[]
}



export interface Segment {
	Start: number
	End: number
	Row: HighlightRow
}